import { MutationHookOptions, useMutation } from '@apollo/client';

import mutation from './createContactBulkImport.graphql';

export const useCreateContactBulkImportMutation = (
  opts?: MutationHookOptions<
    CreateContactBulkImportMutation,
    CreateContactBulkImportMutationVariables
  >,
) => {
  return useMutation<
    CreateContactBulkImportMutation,
    CreateContactBulkImportMutationVariables
  >(mutation, opts);
};
